export function safeNumber(n: unknown): number {
  const num = Number(n)
  return isNaN(num) ? 0 : num
}

export function formatCOP(value: number): string {
  return `$${safeNumber(value).toLocaleString('en-US', { maximumFractionDigits: 0 })}`
}
